/**
 * Chemin de l'ecran des statistiques d'usage.
 *
 * Module **pur**, comme `admin/operations/routes.ts` : le menu (`ui/navigation.ts`)
 * et `App.tsx` l'importent tous deux, et un chemin ecrit en clair aux deux
 * endroits se maintiendrait deux fois.
 */

export const STATISTICS_PATH = '/statistics';
